import {
	Message
} from 'element-ui'
import util from '@/libs/util'
import router from '@/router'
import {
	SYS_USER_LOGIN,
	SYS_USER_LOGIN_BY_CODE,
	SYS_USER_INFO,
	SYS_LOGIN_FOR_CLIENT,
} from '@/api/sys.user.js'
import {
	POST_ENTITY,
} from '@/api/api.commons.js'
import jwt from 'jsonwebtoken'
import lenye_base from 'lenye_base'

const apiServerUrl = process.env.VUE_APP_LYAI_JUHEAPI
const authUrl = "//" + window.location.host

const loginBySaasApi = async function({
	username,
	password
}) {
	if (process.env.NODE_ENV === 'production') {
		lenye_base({
			api: apiServerUrl,
			domain: window.location.host,
			root: true
		})
	} else {
		lenye_base({
			api: apiServerUrl,
			domain: 'jxaqy.learnyeai.com',
			root: true
		})
	}

	return new Promise((resolve, reject) => {
		const url = `${lenye_base.base_data.getapiUrl()}/base-service/login/passwordLogin.do`
		lenye_base.httpPost(url, lenye_base.base_data.getformatting({
			loginName: username,
			password: password,
		}), (e) => {
			if (e.success !== '1') {
				Message({
					message: e.message,
					type: 'error',
					duration: 1000
				})
				reject(e)
			} else {
				lenye_base.user_data.setuserData(e.data)
				resolve(e.data)
			}
		})
	})
}

const loginByRegist = async function({
	userinfo,
	scope
}) {
	return new Promise((resolve, reject) => {
		SYS_LOGIN_FOR_CLIENT({
			client_id: 'root',
			client_secret: 'root',
			scope,
		}).then(({
			access_token,
			token_type
		}) => {
			let data = JSON.parse(lenye_base.base_data.getformatting())
			if (data) {
				POST_ENTITY({
					uri: 'lyaiCustomConnections',
					data: {
						custId: userinfo.custId,
						custType: userinfo.custType,
						username: userinfo.loginName,
						server: apiServerUrl.startsWith("http")? apiServerUrl : "http:" + apiServerUrl,
						clientOS: data.header['CLIENT_OS'],
						sessionToken: data.header['SESSION_TOKEN'],
						siteId: data.header['SITE_ID'],
						uuid: data.header['UUID'],
						time: data.header['REQ_TIME']
					},
					headers: {
						Authorization: `${token_type} ${access_token}`
					}
				})
			}
			POST_ENTITY({
				uri: `/systemUsers`,
				data: {
					id: userinfo.custId,
					name: userinfo.custName,
					username: userinfo.loginName,
					phone: userinfo.phone,
					email: userinfo.email === "" ? undefined : userinfo.email,
					photo: userinfo.photo,
					password: `{noop}${userinfo.custId}`,
				},
				headers: {
					Authorization: `${token_type} ${access_token}`
				}
			}).then(resolve, reject)
		})
	})
}

export default {
	namespaced: true,
	state: {
		userinfo: undefined,
		signinfo: undefined,
		tokeninfo: undefined,
		load: false,
	},
	getters: {
		isSigned(state) {
			return state.signinfo !== undefined
		},
		Authorization(state) {
			return state.signinfo &&
				`${state.signinfo.token_type} ${state.signinfo.access_token}`
		},
		refresh_token(state) {
			return state.signinfo && state.signinfo.refresh_token
		},
		access_token(state) {
			return state.signinfo && state.signinfo.access_token
		},
		username(state) {
			if (state.userinfo) {
				if (state.userinfo.proxy) {
					if (state.userinfo.proxy.name) {
						return state.userinfo.proxy.name
					}
					if (state.userinfo.username) {
						return state.userinfo.proxy.username
					}
				}
				if (state.userinfo.name) {
					return state.userinfo.name
				}
				if (state.userinfo.username) {
					return state.userinfo.username
				}
			}
			return state.tokeninfo && state.tokeninfo.user_name
		},
		mine(state) {
			return (userinfo) => {
				return userinfo.id === state.userinfo.id
			}
		},
		authorities(state) {
			return state.userinfo.authorities.map(t => t.authority)
		},
		hasAuthoritiy(state) {
			return (type, table, field) => {
				const search = [type, table, field].filter(t => t !== undefined).join("::")
				if (!state.userinfo) {
					return false
				}
				if (state.userinfo.id === 'root') {
					return true
				}
				if (state.userinfo.authorities.length === 0) {
					return false
				}
				for (let t of state.userinfo.authorities) {
					if (t.authority === 'ROLE_ADMIN') {
						return true
					}
					if (search.startsWith(t.authority)) {
						return true
					}
				}
				return false
			}
		},
		hasOneAuthoritiy(state) {
			return (authority) => {
				if (!state.userinfo) {
					return false
				}
				if (state.userinfo.id === 'root') {
					return true
				}
				console.log(state.userinfo.authorities, state.userinfo.authorities.length === 0)
				if (state.userinfo.authorities.length === 0) {
					return false
				}
				for (let t of state.userinfo.authorities) {
					if (t.authority === 'ROLE_ADMIN') {
						return true
					}
					if (t.authority === authority) {
						return true
					}
				}
				return false
			}
		},
		photo(state) {
			if (state.userinfo && state.userinfo.photo) {
				return state.userinfo.photo
			}
		},
		uuid(state) {
			return state.userinfo && state.userinfo.id
		},
	},
	mutations: {
		set_token(state, data = {}) {
			state.signinfo = data
			state.tokeninfo = jwt.decode(data.access_token)
		},
		set_userinfo(state, data = {}) {
			state.userinfo = data
		},
		load(state) {
			state.load = true
		},
		clear(state) {
			state.signinfo = undefined
			state.tokeninfo = undefined
			state.userinfo = undefined
		}
	},
	actions: {
		async loginBySaaS({
			dispatch
		}, {
			username,
			password
		}) {
			if (username === 'root') {
				await dispatch('login', {
					username,
					password,
					scope: ''
				})
				return
			}
			const userinfo = await loginBySaasApi({
				username,
				password
			})
			await dispatch('loginByUserinfo', userinfo)
		},

		async loginByLyai({
			dispatch
		}) {
			const userinfo = lenye_base.user_data.getuserData()
			await dispatch('loginByUserinfo', userinfo)
		},

		async loginByUserinfo({
			dispatch
		}, userinfo) {
			const scope = ""

			if (!userinfo) {
				if (process.env.NODE_ENV !== 'production') {
					await dispatch('login', {
						username: 'root',
						password: 'root',
						scope
					})
					return
				} else {
					router.push({
						name: 'login'
					})
					return
				}
			}

			await loginByRegist({
				userinfo,
				scope
			})

			await dispatch('login', {
				username: userinfo.loginName,
				password: userinfo.custId,
				scope
			})
		},

		async login({
			commit,
			dispatch,
		}, {
			username,
			password,
			scope
		}) {
			const token = await SYS_USER_LOGIN({
				username,
				password,
				scope
			})
			try {
				util.cookies.set('token_type', token.token_type)
				util.cookies.set('access_token', token.access_token)
				util.cookies.set('refresh_token', token.refresh_token)
			} catch (e) {
				console.error(e)
			} finally {
				commit('set_token', token)
			}

			await dispatch('load', false)
		},

		async login_by_code({
			commit,
			dispatch
		}, data) {
			const token = await SYS_USER_LOGIN_BY_CODE(data)
			try {
				util.cookies.set('token_type', token.token_type)
				util.cookies.set('access_token', token.access_token)
				util.cookies.set('refresh_token', token.refresh_token)
			} catch (e) {
				console.error(e)
			} finally {
				commit('set_token', token)
			}

			dispatch('load', false)
		},

		async logout({
			commit
		}) {
			commit('clear')
			commit('mine/clear', true, {
				root: true
			})
			util.cookies.remove('token_type')
			util.cookies.remove('access_token')
			util.cookies.remove('refresh_token')

			new Promise(() => {
				const isloginurl = "https://portal." + lenye_base.url.gettopUrl();
				let Logincode = lenye_base.login_third.init(
					function() {}, {
						isLoginUrl: isloginurl + '/auth/isLogin',
						type: 'islogin',
						redirectUrl: window.location.href
					})
				if (Logincode && Logincode.code && Logincode.state) {
					lenye_base.login_third.loginOut({
						redirectUrl: window.location.href,
						logoutUrl: authUrl + '/usercenter-service/security/logout'
					}, () => {
						lenye_base.user_data.loginOut()
						router.push({
							name: 'login'
						})
					})
				} else {
					lenye_base.user_data.loginOut()
					router.push({
						name: 'login'
					})
				}
			}).catch(() => {
				router.push({
					name: 'login'
				})
			})
		},

		/**
		 * @description 用户登录后从持久化数据加载一系列的设置
		 * @param {Object} context
		 */
		async load({
			commit,
			dispatch,
			state 
		}) {
			
			try {
				const token_type = util.cookies.get('token_type') || state.token.token_type || 'bearer'
				const access_token = util.cookies.get('access_token') || state.token.access_token
				const refresh_token = util.cookies.get('refresh_token') || state.token.token.refresh_token
				if (access_token && refresh_token) {
					commit('set_token', {
						token_type,
						access_token,
						refresh_token
					})
				}
			} catch (e) {
				console.error(e)
			}
			if (state.userinfo === undefined) {
				const userinfo = await SYS_USER_INFO()
				commit('set_userinfo', userinfo)
			}
			
			if (state.load) {
				return
			}
			await dispatch('mine/clients/load', true, {
				root: true
			})
			await dispatch('system/generals/load', true, {
				root: true
			})
			await dispatch('mine/generals/load', true, {
				root: true
			})
			await dispatch('global/resources/load', true, {
				root: true
			})
			commit('load')
		}
	}
}
